import { Star, ShieldCheck, Clock, FileText, Award } from "lucide-react";
import { Reveal } from "./shared";

const ITEMS = [
  {
    icon: (
      <span className="flex h-10 w-10 items-center justify-center rounded-full border border-zinc-200 font-display text-xl font-bold text-[#4285F4]">
        G
      </span>
    ),
    top: (
      <span className="flex gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={14} className="fill-[var(--primary)] text-[var(--primary)]" />
        ))}
      </span>
    ),
    label: "5.0 no Google · 8 avaliações",
  },
  { icon: <Award size={26} className="text-zinc-700" />, top: <b className="font-display text-2xl text-zinc-900">+10</b>, label: "Anos de experiência" },
  { icon: <ShieldCheck size={26} className="text-zinc-700" />, top: <b className="font-display text-2xl text-zinc-900">NBR 15526</b>, label: "Norma certificada" },
  { icon: <Clock size={26} className="text-zinc-700" />, top: <b className="font-display text-2xl text-zinc-900">Atendimento</b>, label: "Emergencial" },
  { icon: <FileText size={26} className="text-zinc-700" />, top: <b className="font-display text-2xl text-zinc-900">Orçamento</b>, label: "Transparente" },
];

export const TrustBar = () => (
  <div className="relative z-20 mx-auto -mt-16 max-w-6xl px-5" data-testid="trust-bar">
    <Reveal>
      <div className="grid grid-cols-2 gap-6 rounded-2xl border border-zinc-100 bg-white p-7 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.25)] sm:grid-cols-3 lg:grid-cols-5">
        {ITEMS.map((item, i) => (
          <div key={i} className="flex flex-col items-center gap-1.5 text-center" data-testid={`trust-item-${i}`}>
            {item.icon}
            {item.top}
            <span className="text-xs text-zinc-500">{item.label}</span>
          </div>
        ))}
      </div>
    </Reveal>
  </div>
);
